


























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import router from "@root/router/index.ts";
import addRoutes from "@root/lib/addRoutes";
import MenuLink from "./Link.vue";

import Cookies from "js-cookie";
import { isExternal } from "@root/utiles/validate";

const Root = namespace("root");
const login = namespace("login");

@Component({ components: { MenuLink } })
export default class Menu extends Vue {
  @Root.State isCollapse;
  @Root.Mutation easyMutate;
  @Root.Action menuListByRole;
  @login.Action loginB2BSSO;
  @login.Action loginZSTSSO;
  @login.Action tbrLoginZSTSSO;
  @login.Action tbrLoginQipei;
  @Root.Getter menuList;
  @Root.State activeRoute;

  private showMenu = false;
  private gitiApiUrlB2B = "";
  private gitiApiUrlZST = "";
  private gitiApiUrlZSTTbr = "";
  qipeiUrl: any = "qipei";

  get appName() {
    return process.env.APP_NAME || "G-Tech";
  }

  get userInfo() {
    return JSON.parse(localStorage.getItem("userInfo"));
  }
  selectedMenu: any = "";
  @Watch("$route", { immediate: true })
  onRouteChange(to, from: any = {}) {
    this.selectedMenu = this.getRoutePath(
      to.meta.activePath || to.meta.activeMenuIndex || to.path,
      to
    );
  }

  @Watch("activeRoute", { immediate: true })
  onActiveRouteChange(to, from: any = {}) {
    if (to.meta && to.meta.activeMenuIndex) {
      this.selectedMenu =
        (to.meta.appPrev || "") + to.meta.activeMenuIndex || to.path;
    }
  }

  created() {
    this.pageInit();
  }

  async pageInit() {
    // menu
    try {
      console.log("menu");
      let roleCode: any = localStorage.getItem("menuRoleCode");
      const menuList = await this.menuListByRole({
        roleCode
      });
      if (menuList && menuList.length === 0) {
        // by.zhangjiabo
        // 登录阶段已经判断过这个了 无需再次判断
        // this.$router.push({ name: "Login" });
        // this.$message.warning("当前用户无任何菜单，请联系管理员！");
      } else {
        addRoutes(router);
      }

      // add by jiabo.zhang
      if (process.env.VUE_APP_EXTERNAL_LOGIN === "TRUE") {
        // 这个是原来的逻辑 note by jiabo.zhang
        this.gitiApiUrlB2B = await this.getJumpUrl("loginB2BSSO");
        this.gitiApiUrlZST = await this.getJumpUrl("loginZSTSSO");
        this.gitiApiUrlZSTTbr = await this.getJumpUrl("tbrLoginZSTSSO");
      }
      this.gitiApiUrlZSTTbr = await this.getJumpUrl("tbrLoginZSTSSO");
    } catch (error) {
      console.log(error);
    } finally {
      this.showMenu = true;
    }
    // collapse
    const isCollapse = Cookies.get("sidebarStatus") === "true";

    // sync
    this.handleCollapseMenu(isCollapse, false);
  }

  handleCollapseMenu(targetValue = true, writeIntoCookies = true) {
    // mutate
    this.easyMutate({ path: "isCollapse", data: targetValue });

    // cookies
    if (writeIntoCookies) {
      Cookies.set("sidebarStatus", String(targetValue));
    }
  }

  // 设置自定义菜单
  setCustomMenu(list) {
    this.easyMutate({
      path: `menuList`,
      data: list
    });
  }

  getRoutePath(pathStr, route) {
    // TODO: 只是简单的判断路径是否是以 "/" 开头
    const {
      meta: { hasMenu = false }
    } = route;
    const isValid = /^(\/).*/.test(String(pathStr));
    if (isValid) {
      // 修复路径不能是空字符，不然会高亮无路径的菜单
      // return hasMenu ? pathStr : "/";
      return pathStr;
    } else {
      return `/${pathStr}`;
    }
  }
  getDetailPath(routePath, routeName) {
    // 如果是指定的获取第三方，则修改链接 :)
    // 无pageUrl的菜单，不进行跳转
    if (typeof routePath === "undefined" || routePath === this.qipeiUrl) {
      return "";
    }
    if (isExternal(routePath)) {
      if (routeName.indexOf("B2B") > -1) {
        return this.gitiApiUrlB2B;
      } else if (routeName.indexOf("掌上通") > -1) {
        const marketType = localStorage.getItem("marketType");
        return marketType === "TBR"
          ? this.gitiApiUrlZSTTbr
          : this.gitiApiUrlZST;
      }
    }

    return String(routePath);
  }
  /**
   * FIXME：备注下，这里先写死一个需求，无菜单的时候，单击菜单栏不做跳转，只是提示，“请前往K1 APP访问”
   */
  async onClickDetailPath(routePath) {
    if (typeof routePath === "undefined") {
      this.$confirm("请前往K1 APP访问", "提示", {
        confirmButtonText: "确定",
        showCancelButton: false,
        type: "warning"
      });
    }
    if (routePath === this.qipeiUrl) {
      let url: any = await this.tbrLoginQipei();
      window.open(url, "_blank");
    }
  }
  resolvePath(routePath) {
    if (isExternal(routePath) || !routePath || routePath === this.qipeiUrl) {
      // return Math.random().toString();
      return Math.random();
    }
    return routePath;
  }
  async getJumpUrl(loginURL) {
    try {
      const { orgCode } = this.userInfo;
      const {
        data: { api = "" }
      } = await this[loginURL]({
        orgCode
      });
      if (api) {
        return api;
      } else {
        this.$message.error("链接为空！");
      }
    } catch (error) {
      console.log(error);
    }
  }

  onHeaderClick() {
    this.$router.push("/");
  }
}
